import { toast } from "sonner";

export const toastSuccess = (value) => {
  return toast.success(`${value}`, { duration: 3000 });
};

export const toastError = (value) => {
  return toast.error(`${value}`, { duration: 3000 });
};
